import ExpandDownCircleFilled from '@ixigo/icons/ExpandDownCircleFilled';
import { InlineAlert } from '@ixigo/iui/InlineAlert';
import Typography from '@ixigo/iui/Typography';
import { RupeeChecked } from '@repo/shared/icons';
import cn from '@repo/shared/utils/cn';
import type { BaseBookingDetail, BookingSuccessResponse } from '@/api';
import {
	FAILED_BOOKING_STATUS,
	PENDING_BOOKING_STATUS,
} from '@/routes/_auth/-components/constants';
import { CustomerHelp } from '../customer-help';
import { ConfirmWidget } from './confirm-widget';
import PendingWidget from './pending-widget/container';

export interface TripWidgetProps
	extends Pick<
		BookingSuccessResponse['data'],
		'cancellationDetail' | 'rescheduleDetail' | 'refundDetail'
	> {
	bookingDetail: Pick<
		BaseBookingDetail,
		| 'eticketUrl'
		| 'invoiceUrl'
		| 'advanceReceiptUrl'
		| 'commuteMsg'
		| 'bookingStatus'
		| 'bookingId'
		| 'pendingInfo'
	>;
	className?: string;
}

export const TripWidget = (props: TripWidgetProps) => {
	const { bookingDetail, cancellationDetail, rescheduleDetail, refundDetail } =
		props;
	const { bookingStatus, pendingInfo } = bookingDetail;
	const refundMsg = refundDetail?.msg;
	const isPendingBooking = PENDING_BOOKING_STATUS.includes(bookingStatus);
	const isFailedBooking = FAILED_BOOKING_STATUS.includes(bookingStatus);

	return (
		<div
			className={cn(
				'w-full border border-tertiary rounded-20 overflow-hidden',
				props.className,
			)}
		>
			{isFailedBooking || isPendingBooking ? (
				<div className="flex flex-col gap-15 p-15">
					{isPendingBooking && pendingInfo && (
						<PendingWidget
							infoText={pendingInfo.msg}
							durationMs={pendingInfo.durationMs || 0}
							startTimeEpoch={pendingInfo.startTimeEpoch || 0}
						/>
					)}
					{refundMsg && (
						<InlineAlert
							severity="success"
							textColor="auto"
							className="items-start"
							title={
								<Typography
									variant="body-xs"
									// biome-ignore lint/security/noDangerouslySetInnerHtml: <static data just to show refund msg>
									dangerouslySetInnerHTML={{
										__html: refundMsg,
									}}
								/>
							}
							icon={<RupeeChecked className="flex-shrink-0" />}
							closeBtnContent={<ExpandDownCircleFilled />}
							onClose={() => {
								// TODO: @ujjwal add logic here
							}}
						/>
					)}
					<CustomerHelp className="border border-tertiary rounded-20 overflow-hidden p-15 pb-10" />
				</div>
			) : (
				<ConfirmWidget
					bookingDetail={bookingDetail}
					refundDetail={refundDetail}
					cancellationDetail={cancellationDetail}
					rescheduleDetail={rescheduleDetail}
				/>
			)}
		</div>
	);
};
